import { render, staticRenderFns } from "./newQAhome.vue?vue&type=template&id=235badee&scoped=true&"
import script from "./newQAhome.vue?vue&type=script&lang=js&"
export * from "./newQAhome.vue?vue&type=script&lang=js&"
import style0 from "./newQAhome.vue?vue&type=style&index=0&id=235badee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235badee",
  null
  
)

export default component.exports